const ua = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : ''

// iPhone
export const isIOS = (ua.indexOf('iphone') > 0) || ua === 'tantan-ios'
// 安卓
export const isAndroid = (ua.indexOf('android') > 0)

export const REPORT_LIMIT = 5

export const OPERATION_LIMIT = 100

export const baseURL = ''

export const MONTH_STR = {
  0: 'JAN',
  1: 'FEB',
  2: 'MAR',
  3: 'APR',
  4: 'MAY',
  5: 'JUN',
  6: 'JUL',
  7: 'AUG',
  8: 'SEP',
  9: 'OCT',
  10: 'NOV',
  11: 'DEC',
}
